export type CompetencyType = {
  id: string;
  identity_code: string;
  title: string;
  description: string;
  competency_code: string;
  required: boolean;
  // pass_fail: boolean;
  specified: boolean;
  knowledge_area_id: string;
  knowledge_area_title: string;
  available: boolean;
  semester_name: string;
  date_available: string;
  // instructor: string;
  instructors: string;
  credits: number;
  min_optional: number;
  prerequisites: any;
  semester_detail: any;
  pillar_title: string;
  pillar_id: string;
  subdomain_id: string;
  subdomain_title: string;
  area_map: any;
  option_group: any;
  display_version?: string;
  version_status?: string;
  program_name?: string;
  derived_from_version?: string;
  curriculum_version?: number;
  university_code?: string;
  skills: Array<{
    id: string;
    title: string;
    description: string;
    skill_code: string;
    required: boolean;
    assessment: {
      id: string;
      title: string;
      description: string;
      external_url: string;
    };
  }>;
  graphics: {
    icon: string;
    iconbg: string;
    bordercolor: string;
    iconshadow: string;
    imgurl: string;
  };
  derived_from_code?: string;
  has_cards?: boolean;
  derived_from_id?: string;
  derived_from_program?: string;
  original_skill_count?: number;
};
export const EmptyCompetency: CompetencyType = {
  id: "",
  identity_code: "",
  title: "",
  description: "",
  competency_code: "",
  required: false,
  display_version: "",
  program_name: "",
  // pass_fail: false,
  option_group: [],
  area_map: {
    core_technical: false,
    math_science: false,
    social_communication_arts: false,
    research: false,
    soft_skill: false,
    xp: false,
  },
  specified: false,
  available: false,
  knowledge_area_id: "",
  knowledge_area_title: "",
  semester_name: "",
  date_available: "",
  // instructor: "",
  instructors: "",
  pillar_title: "",
  pillar_id: "",
  subdomain_title: "",
  subdomain_id: "",
  credits: 0,
  min_optional: 0,
  prerequisites: null,
  semester_detail: null,
  skills: [
    {
      id: "",
      title: "",
      description: "",
      skill_code: "",
      required: false,
      assessment: {
        id: "",
        title: "",
        description: "",
        external_url: "",
      },
    },
  ],
  graphics: {
    icon: "",
    iconbg: "",
    bordercolor: "",
    iconshadow: "",
    imgurl: "",
  },
  derived_from_code: "",
  has_cards: false,
  derived_from_id: "",
  derived_from_program: "",
  derived_from_version: "",
  original_skill_count: 0,
};
